/// <reference path="../../../../typings/tsd.d.ts" /> 
module warsApp.controllers {

    export interface ISecurityMatrixConditionModalScope extends IBaseModalControllerScope {
        matrix: any;
        state: any, claim: any;
        conditions: Wars.Domain.Model.Conditions.Condition[];
        conditionChanged: any;
        selectedCondition:Wars.Domain.Model.Conditions.Condition;
    }

    export class SecurityMatrixConditionModalController extends BaseModalController {
        scope: ISecurityMatrixConditionModalScope;

        constructor($scope: ISecurityMatrixConditionModalScope,matrix: any, state: any, claim: any,
            conditions: Wars.Domain.Model.Conditions.Condition[], close: any) {

            super($scope, close);

            this.scope = $scope;
            this.scope.matrix=matrix;
            this.scope.state = state;
            this.scope.claim = claim;
            this.scope.conditions = conditions;

            if (matrix[state.id]) {
                if (matrix[state.id][claim.id] && matrix[state.id][claim.id].condition_id) {
                    this.scope.selectedCondition=Enumerable.from(this.scope.conditions)
                        .singleOrDefault(c => c.id === matrix[state.id][claim.id].condition_id);
                }
            }
            

            this.scope.conditionChanged = () => {
                if (!matrix[state.id]) {
                    matrix[state.id] = {
                    
                    };
                }

                matrix[state.id][claim.id] = {
                    selected: false,
                    condition_id: this.scope.selectedCondition.id
                } 
            }
        }
    }
}

warsApp.registerController('SecurityMatrixConditionModalController', ['$scope', 'matrix','state','claim','conditions', 'close']);